module.exports = __webpack_public_path__ + "static/media/arrowRight.b5c13cbf.svg";